require('../../../retail/js/feature/component-site-notification-spot.js');